import { useEffect, useState } from "react";
import { Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { clearRetouchAdminToken, getRetouchAdminToken, verifyRetouchAdminToken } from "../../utils/retouchReviewAdminAuth";

function RetouchRequireAdmin({ children }) {
    const navigate = useNavigate();
    const [ready, setReady] = useState(false);

    useEffect(() => {
        let active = true;
        verifyRetouchAdminToken(getRetouchAdminToken()).then((ok) => {
            if (!active) return;
            if (ok) setReady(true);
            else {
                clearRetouchAdminToken();
                navigate("/", { replace: true });
            }
        });
        return () => { active = false; };
    }, [navigate]);

    if (!ready) return <div className="retouch-review-loading"><Spin size="large" /></div>;
    return children;
}

export default RetouchRequireAdmin;
